export interface ConfirmSignUpOptions {
    // Doc: https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_AdminCreateUser.html#CognitoUserPools-AdminCreateUser-request-ForceAliasCreation
    forceAliasCreation?: boolean
}